import CheckmateApiClient from '../../../services/apiClient';
import { useQuery } from 'react-query';

const _apiClient = new CheckmateApiClient();

export const useGetQuadZoneNoteTargets = (
    organizationGuids: string[] | undefined,
    isQuadNoteEditor?: boolean | undefined
) => {
    return useQuery({
        queryKey: ['get-quad-zone-note-targets', { organizationGuids }],
        queryFn: async () => {
            const response = await _apiClient.getQuadZoneNoteTargets(organizationGuids);

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (!response.httpResponse.ok) {
                throw new Error(response.errorMessage ?? 'Failed to retrieve quad zone note targets.');
            }

            return response.payload;
        },
        enabled: !!organizationGuids && organizationGuids.length > 1 && isQuadNoteEditor,
    });
};
